import Vue from "vue";
import ElementUI from "element-ui";
//样式文件需要单独引入
import "element-ui/lib/theme-chalk/index.css";

import less from "less";
import App from "./App.vue";

import * as echarts from "echarts";
import router from "./router";
import store from "./vuex/store"; // 引入store
import i18n from "./i18n";
import { getToken, isManager } from "@/utils/auth.js";
import notify from "@/utils/notify.js";
import { createPagePermissionRecovery } from "@/utils/pagePermissionRecovery.js";
// 系统样式重置
import "@/assets/css/reset.css";
import "@/assets/iconfont/iconfont.css";
// 全局样式
import "@/styles/global.less";
// Tailwind CSS - 暂时注释掉，改为在组件中局部引入
// import "@/styles/tailwind.css";

Vue.use(ElementUI);
Vue.use(less);
Vue.config.productionTip = false;
// 将echarts绑定到Vue的原型链上
Vue.prototype.$echarts = echarts;

const app = new Vue({
  render: (h) => h(App),
  router,
  store,
  i18n,
}).$mount("#app");

const recoverPagePermission = createPagePermissionRecovery({ router, store, getToken, isManager, notify });
window.addEventListener("yt:page-permission-denied", (event) => {
  recoverPagePermission(event.detail && event.detail.route);
});

window.addEventListener("yt:auth-cleared", () => {
  app.$store.dispatch("permission/reset");
});
